<template>
    <div class="container" :class="seasonClass">
        <div class="screen" :style="pageStyle">
            <template v-if="!isSelectExamRoom">
                <div class="flex-box">
                    <div class="season2">
                        <!-- 表单选择区域 -->
                        <div class="form-container">
                            <div class="form-item">
                                <label>赛区：</label>
                                <el-select
                                    v-model="queryForm.districtId"
                                    placeholder="请选择赛区"
                                    @change="handleDistrictChange"
                                >
                                    <el-option
                                        v-for="item in dict_district"
                                        :key="item.id"
                                        :label="item.districtName"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="form-item">
                                <label>考场：</label>
                                <el-select
                                    v-model="queryForm.examinationRoomId"
                                    placeholder="请选择考场"
                                    @change="handleExamRoomChange"
                                >
                                    <el-option
                                        v-for="item in examRooms"
                                        :key="item.id"
                                        :label="item.roomName"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="form-item">
                                <div class="confirm-btn" @click="handleConfirm">确认 | Confirm</div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="input-container">
                    <div class="title" style="margin-bottom: 0px;">
                        请输入你的比赛号码
                    </div>
                    <div class="title">Please enter your race number</div>
                    <el-input
                        class="input"
                        v-model="queryForm.examinationNumber"
                        type="number"
                        :readonly="dialogVisible"
                        placeholder="请输入比赛号码"
                    ></el-input>
                    <div class="button-group">
                        <div class="reselect-btn" @click="handleReselect">重选考场 | Reselect</div>
                        <div class="search" @click="getInfo">登录 | Login</div>
                    </div>
                </div>
            </template>
        </div>
        <el-dialog
            :visible.sync="dialogVisible"
            :show-close="false"
            :close-on-click-modal="false"
            :custom-class="seasonClass === 'season1' ? 'responsive-dialog' : 'season2-dialog responsive-dialog'"
            :width="getDialogWidth()"
        >
            <div class="info-panel" :class="'info-panel-' + seasonClass">
                <div class="info-title">
                    <div class="cn">请确认你的个人信息</div>
                    <div class="en word-break">
                        Please confirm your information.
                    </div>
                </div>
                <div class="info-con">
                    <div
                        class="info-item"
                        v-for="(value, key) in info"
                        :key="key"
                    >
                        <div class="key">
                            <div class="cn">{{ key }}</div>
                            <div class="en">{{ getEn(key) }}</div>
                        </div>
                        <div class="value">
                            {{ value }}
                        </div>
                    </div>
                </div>
                <div class="info-btns">
                    <div class="btn btn1" @click="closeFn">返回 | Cancel</div>
                    <div class="btn btn2" @click="confirmFn">
                        确认 | Confirm
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { selectByRoomAndNum, saveSignStatus } from '@/http/wxApi'
import env from '@/http/env'

export default {
  data () {
    return {
      base: env.baseWebIP,
      seasonClass: 'season2',
      screenWidth: 0,
      screenHeight: 0,
      pageStyle: {
        width: '100%'
      },
      query: {},
      dict_district: [
        {
          districtName: '上海选区',
          id: '19'
        },
        {
          districtName: '北京选区',
          id: '10'
        },
        {
          districtName: '杭州选区',
          id: '43'
        },
        {
          districtName: '天津选区',
          id: '9'
        }
      ], // 赛区数据
      dict_grade: [
        { dictCode: '1', dictLabel: '一年级' },
        { dictCode: '2', dictLabel: '二年级' },
        { dictCode: '3', dictLabel: '三年级' },
        { dictCode: '4', dictLabel: '四年级' },
        { dictCode: '5', dictLabel: '五年级' },
        { dictCode: '6', dictLabel: '六年级' },
        { dictCode: '7', dictLabel: '七年级' },
        { dictCode: '8', dictLabel: '八年级' },
        { dictCode: '9', dictLabel: '九年级' }
      ], // 年级数据
      dict_group: [
        { dictCode: '1', cn: '小学组', en: 'Primary School' },
        { dictCode: '2', cn: '初中组', en: 'Junior High School' },
        { dictCode: '3', cn: '高中组', en: 'Senior High School' }
      ], // 组别数据
      examRooms: [], // 考场下拉列表
      loading: false,
      dialogVisible: false,
      info: {}, // 参赛者信息
      userId: '', // 参赛者ID
      userLevel: '', // 参赛者级别
      cnTitle: '汉英双拼大会',
      enTitle: 'Chinese English Bilingual Spelling Bee',
      padUserInfo: {}, // 参赛者信息
      isFull: false, // 是否全屏
      group: 1, // 有组别
      isSelectExamRoom: false, // 是否选择考场
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$route.query.season || '2024~2025',
        districtId: '',
        examinationRoomId: '',
        raceSchedule: '2',
        examinationNumber: ''
      }
    }
  },
  created () {
    // 检查本地存储中是否有考场数据
    const examRoomData = localStorage.getItem('EXAM_ROOM_DATA')
    if (examRoomData) {
      try {
        const data = JSON.parse(examRoomData)
        if (data.returnToInput) {
          // 从本地存储恢复数据
          this.restoreExamRoomData(data)
        } else {
          // 正常流程，获取赛区列表
          this.getDistrictList()
        }
      } catch (error) {
        console.error('解析本地存储数据失败:', error)
        // 如果解析失败，走正常流程
        this.getDistrictList()
      }
    } else {
      // 正常流程，获取赛区列表
      this.getDistrictList()
    }
  },
  methods: {
    // 获取赛区筛选数据
    getDistrictList () {
      this.queryForm.districtId = this.dict_district[0].id
      this.getExamRoomSelect()
    },
    // 从本地存储恢复考场数据
    restoreExamRoomData (data) {
      // 设置赛区ID
      if (data.districtId) {
        this.queryForm.districtId = data.districtId
      }
      // 设置考场ID
      if (data.examinationRoomId) {
        this.queryForm.examinationRoomId = data.examinationRoomId
      }
      // 设置其他参数
      if (data.season) this.queryForm.season = data.season
      if (data.activityType) this.queryForm.activityType = data.activityType
      if (data.raceSchedule) this.queryForm.raceSchedule = data.raceSchedule
      if (data.group) this.group = data.group
      if (data.level) this.level = data.level
      if (data.phase) this.phase = data.phase

      // 清空比赛号码，让下一位选手输入
      this.queryForm.examinationNumber = ''
      // 直接设置为输入界面状态
      this.isSelectExamRoom = true
      this.getExamRoomSelect()
    },
    // 获取考场列表
    getExamRoomSelect () {
      if (!this.queryForm.districtId) {
        console.warn('赛区ID未设置，无法获取考场列表')
        return
      }
      this.$http.get(`${this.base}common/examination/queryExaminationList?districtId=${this.queryForm.districtId}`).then(res => {
        if (res.code === 200) {
          this.examRooms = res.data
        }
      })
    },
    // 赛区变化处理
    handleDistrictChange (value) {
      this.queryForm.examinationRoomId = ''
      // 清除本地存储的考场数据，因为赛区已改变
      localStorage.removeItem('EXAM_ROOM_DATA')
      this.getExamRoomSelect()
    },
    // 考场变化处理
    handleExamRoomChange (value) {
      console.log('选择的考场ID:', value)
      // 清除本地存储的考场数据，因为考场已改变
      localStorage.removeItem('EXAM_ROOM_DATA')
    },
    // 确认按钮处理
    handleConfirm () {
      if (!this.queryForm.districtId) {
        this.$message.warning('请选择赛区')
        return
      }
      if (!this.queryForm.examinationRoomId) {
        this.$message.warning('请选择考场')
        return
      }
      // 清除本地存储的考场数据，因为用户确认了新的选择
      localStorage.removeItem('EXAM_ROOM_DATA')
      this.isSelectExamRoom = true
    },
    getInfo () {
      if (!this.queryForm.examinationNumber) {
        this.$message.warning('请输入比赛号码')
        return
      }
      this.queryForm.examinationNumber = this.addZero(this.queryForm.examinationNumber)
      if (this.loading) return
      this.loading = true
      console.log('发送请求参数:', this.queryForm)
      selectByRoomAndNum(this.queryForm).then(res => {
        console.log('接口返回数据:', res)
        if (res.code === 200 && res.data) {
          const obj = {}
          obj['姓 名'] = res.data.examinationUserName || '--'
          obj['手 机 号'] = res.data.examinationUserPhone || '--'
          obj['年 级'] = this.gradeFormatter(res.data.examinationUserGrade) || '--'
          obj['学 校'] = res.data.examinationUserSchoolName || '--'
          obj['比赛号码'] = this.addZero(res.data.examinationNumber) || '--'

          this.info = obj
          this.userId = res.data.userId
          this.padUserInfo = res.data
          localStorage.setItem('PAD_USER_INFO', JSON.stringify(this.padUserInfo))
          localStorage.setItem('WX_TOKEN', res.data.token)
          // 清除本地存储的考场数据，因为用户已成功登录
          localStorage.removeItem('EXAM_ROOM_DATA')
          this.dialogVisible = true
          console.log('弹窗状态:', this.dialogVisible)
          console.log('用户信息:', this.info)
        } else {
          this.$message.error(res.message || '获取用户信息失败')
        }
        this.loading = false
      }).catch(error => {
        console.log('请求错误:', error)
        this.loading = false
      })
    },
    closeFn () {
      this.dialogVisible = false
    },
    confirmFn () {
      this.saveSignStatus()
    },
    saveSignStatus () {
      saveSignStatus({ id: this.padUserInfo.tbEnrollmentRoundInfos[0].id }).then(res => {
        console.log('res', res)
        if (res.code === 200) {
          this.$router.push({ path: '/semiThirdAnswer', query: { season: this.queryForm.season, activityType: this.queryForm.activityType, raceSchedule: this.queryForm.raceSchedule, group: this.group, level: this.padUserInfo.examinationUserLevel, examinationRoomId: this.queryForm.examinationRoomId, phase: '3', districtId: this.queryForm.districtId } })
        }
      }).catch(err => {
        console.log('err', err)
      })
    },
    // 重选考场处理
    handleReselect () {
      this.isSelectExamRoom = false
    },
    // 获取弹窗宽度
    getDialogWidth () {
      const screenWidth = window.innerWidth
      if (screenWidth < 768) {
        return '90%'
      } else if (screenWidth < 1024) {
        return '70%'
      } else if (screenWidth < 1440) {
        return '60%'
      } else {
        return '50%'
      }
    },
    getEn (key) {
      return key === '姓 名' ? 'Name' : key === '手 机 号' ? 'Phone' : key === '年 级' ? 'Grade' : key === '学 校' ? 'School' : key === '比赛号码' ? 'Race Number' : ''
    },
    addZero (num) {
      return this.$xcUtils.addZero(num)
    },
    gradeFormatter (grade) {
      console.log('grade', grade)
      console.log('dict_grade', this.dict_grade)
      return grade ? this.dict_grade.find(item => Number(item.dictCode) === grade).dictLabel : '--'
    },
    levelFormatter (level, type) {
      return this.dict_group.find(item => item.dictCode === level)[type]
    },
    requestFullScreen () {
      const de = document.documentElement
      if (de.requestFullscreen) {
        de.requestFullscreen()
      } else if (de.mozRequestFullScreen) {
        de.mozRequestFullScreen()
      } else if (de.webkitRequestFullScreen) {
        de.webkitRequestFullScreen()
      }
    },
    exitFullscreen () {
      const de = document
      if (de.exitFullscreen) {
        de.exitFullscreen()
      } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen()
      } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen()
      }
    },
    toFullOrExit () {
      this.isFull = !this.isFull
      if (this.isFull) {
        this.requestFullScreen()
      } else {
        this.exitFullscreen()
      }
    }
  }
}
</script>
<style scoped lang="less">
.container {
    width: 100vw;
    height: 100vh;
}
.screen {
    // width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    color: #000;
    font-family: "regular";
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}
.season2 {
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/season2bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .flex-box {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow-x: hidden;
        overflow-y: hidden;
    }
}
// 表单容器样式
.form-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(255, 255, 255, 0.9);
    border-radius: 16px;
    padding: 30px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(10px);
    max-width: 90vw;
    box-sizing: border-box;

    @media (max-width: 768px) {
        padding: 25px;
        border-radius: 14px;
    }

    @media (max-width: 480px) {
        padding: 20px;
        border-radius: 12px;
        width: 85vw;
    }

    @media (max-width: 320px) {
        padding: 15px;
        border-radius: 10px;
        width: 90vw;
    }

    .form-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        @media (max-width: 480px) {
            flex-direction: column;
            align-items: flex-start;
            margin-bottom: 15px;
        }

        &:last-child {
            margin-bottom: 0;
        }

        label {
            font-size: 22px;
            font-weight: 500;
            color: #333;
            margin-right: 15px;
            min-width: 70px;

            @media (max-width: 768px) {
                font-size: 20px;
                margin-right: 12px;
                min-width: 65px;
            }

            @media (max-width: 480px) {
                font-size: 18px;
                margin-right: 0;
                margin-bottom: 8px;
                min-width: auto;
            }

            @media (max-width: 320px) {
                font-size: 16px;
                margin-bottom: 6px;
            }
        }

        .el-select {
            width: 240px;

            @media (max-width: 768px) {
                width: 220px;
            }

            @media (max-width: 480px) {
                width: 100%;
            }

            /deep/ .el-input__inner {
                border-radius: 10px;
                border: 2px solid #dcdfe6;
                background: rgba(255, 255, 255, 0.8);
                font-size: 18px;
                height: 50px;
                line-height: 50px;

                @media (max-width: 768px) {
                    height: 45px;
                    line-height: 45px;
                    font-size: 16px;
                }

                @media (max-width: 480px) {
                    height: 42px;
                    line-height: 42px;
                    font-size: 15px;
                }

                &:focus {
                    border-color: #409eff;
                }
            }

            /deep/ .el-select__caret {
                font-size: 18px;

                @media (max-width: 768px) {
                    font-size: 16px;
                }

                @media (max-width: 480px) {
                    font-size: 14px;
                }
            }
        }

        .confirm-btn {
            width: 100%;
            height: 56px;
            line-height: 56px;
            background: linear-gradient(to bottom, #0c0a03, #373633);
            color: #fff;
            font-size: 22px;
            font-family: "regular";
            border-radius: 10px;
            text-align: center;
            cursor: pointer;
            margin-top: 15px;
            transition: all 0.3s ease;

            @media (max-width: 768px) {
                height: 50px;
                line-height: 50px;
                font-size: 20px;
                margin-top: 12px;
            }

            @media (max-width: 480px) {
                height: 46px;
                line-height: 46px;
                font-size: 18px;
                margin-top: 10px;
            }

            @media (max-width: 320px) {
                height: 42px;
                line-height: 42px;
                font-size: 16px;
                margin-top: 8px;
            }

            &:hover {
                background: linear-gradient(to bottom, #373633, #0c0a03);
                transform: translateY(-2px);
                box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
            }
        }
    }
}

.input-container {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/season2bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    padding: 20px;
    box-sizing: border-box;
}

.title {
    margin: 0 0 50px 0;
    padding: 0px 40px;
    font-size: 30px;
    text-align: center;
    color: #000;
    font-weight: 500;
    line-height: 1.4;

    @media (max-width: 768px) {
        font-size: 26px;
        padding: 0px 30px;
        margin: 0 0 40px 0;
    }

    @media (max-width: 480px) {
        font-size: 22px;
        padding: 0px 20px;
        margin: 0 0 30px 0;
    }

    @media (max-width: 320px) {
        font-size: 20px;
        padding: 0px 15px;
        margin: 0 0 25px 0;
    }
}

.input {
    display: block;
    text-align: center;
    margin: 0 0 50px 0;
    width: 450px;
    height: 60px;
    border: 3px solid #000;
    border-radius: 25px;
    background-color: #fff;
    box-shadow: inset 3px 3px 20px rgba(0, 0, 0, 0.4);
    max-width: 100%;
    box-sizing: border-box;

    @media (max-width: 768px) {
        width: 380px;
        height: 55px;
        margin: 0 0 40px 0;
        border-radius: 22px;
    }

    @media (max-width: 480px) {
        width: 320px;
        height: 50px;
        margin: 0 0 30px 0;
        border-radius: 20px;
    }

    @media (max-width: 320px) {
        width: 280px;
        height: 45px;
        margin: 0 0 25px 0;
        border-radius: 18px;
    }

    /deep/ .el-input__inner {
        height: 60px;
        border: none;
        text-align: center;
        font-size: 32px;
        font-family: "regular";
        color: #000;
        background-color: transparent;
        letter-spacing: 6px;

        @media (max-width: 768px) {
            height: 55px;
            font-size: 28px;
            letter-spacing: 5px;
        }

        @media (max-width: 480px) {
            height: 50px;
            font-size: 24px;
            letter-spacing: 4px;
        }

        @media (max-width: 320px) {
            height: 45px;
            font-size: 20px;
            letter-spacing: 3px;
        }
    }
}
.button-group {
    display: flex;
    align-items: center;
    gap: 40px;
    flex-wrap: wrap;
    justify-content: center;

    @media (max-width: 768px) {
        gap: 30px;
    }

    @media (max-width: 480px) {
        gap: 20px;
        flex-direction: column;
        width: 100%;
        max-width: 320px;
    }

    @media (max-width: 320px) {
        gap: 15px;
        max-width: 280px;
    }
}

.reselect-btn {
    width: 220px;
    height: 65px;
    line-height: 61px;
    background: linear-gradient(to bottom, #6c757d, #495057);
    color: #fff;
    font-size: 22px;
    font-family: "regular";
    border: 3px solid #495057;
    border-radius: 65px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;

    @media (max-width: 768px) {
        width: 200px;
        height: 60px;
        line-height: 56px;
        font-size: 20px;
        border-radius: 60px;
    }

    @media (max-width: 480px) {
        width: 100%;
        height: 55px;
        line-height: 51px;
        font-size: 18px;
        border-radius: 55px;
    }

    @media (max-width: 320px) {
        height: 50px;
        line-height: 46px;
        font-size: 16px;
        border-radius: 50px;
    }

    &:hover {
        background: linear-gradient(to bottom, #495057, #6c757d);
        transform: translateY(-2px);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
    }
}

.search {
    width: 220px;
    height: 65px;
    line-height: 61px;
    background: linear-gradient(to bottom, #0c0a03, #373633);
    color: #fff;
    font-size: 22px;
    font-family: "regular";
    border: 3px solid #000;
    border-radius: 65px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;

    @media (max-width: 768px) {
        width: 200px;
        height: 60px;
        line-height: 56px;
        font-size: 20px;
        border-radius: 60px;
    }

    @media (max-width: 480px) {
        width: 100%;
        height: 55px;
        line-height: 51px;
        font-size: 18px;
        border-radius: 55px;
    }

    @media (max-width: 320px) {
        height: 50px;
        line-height: 46px;
        font-size: 16px;
        border-radius: 50px;
    }

    &:hover {
        background: linear-gradient(to bottom, #373633, #0c0a03);
        transform: translateY(-2px);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
    }
}
.info-panel-season2{
  height: 520px;
  border: none;
  position: relative;
  background-color: transparent;
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/rankbg.png);
  background-repeat: no-repeat;
  background-size: 90% 100%;
  background-position: center;
  padding-top: 50px;
  padding-bottom: 50px;
  box-sizing: border-box;
  .info-con{
    width: 60%;
    background-color: transparent;
    color: #000;
  }
  .info-title{
    color: #fff;
  }
}
.info-panel {
  min-height: 350px;
  max-height: 80vh;
  background-color: #cbae72;
  border-radius: 60px;
  border: 3px solid #000;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    border-radius: 30px;
    min-height: 300px;
  }
}
.info-title{
  margin: 20px auto 10px;
  width: 100%;
  height: 80px;
  padding-top: 16px;
  box-sizing: border-box;
  // line-height: 64px;
  text-align: center;
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  color: #fff;
  .cn{
    font-size: 26px;
  }
  .en{
    font-size: 20px;
  }
}
.info-con {
  min-height: 180px;
  max-height: 40vh;
  margin: 0 auto;
  background-color: #B81C25;
  color: #fff;
  font-size: 18px;
  font-family: fzcsk;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;

  @media (max-width: 768px) {
    width: 92%;
    border-radius: 30px;
    padding: 15px 20px;
    font-size: 16px;
  }
}
.info-item{
  display: flex;
  .key{
    font-size: 18px;
    width: 100px;
    margin-bottom: 8px;
  }
  .en{
    font-size: 12px;
  }
}
.info-btns {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }

  .btn {
    font-size: 22px;
    width: 220px;
    text-align: center;
    height: 48px;
    line-height: 44px;
    justify-content: center;
    border-radius: 48px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;

    @media (max-width: 768px) {
      width: 180px;
      font-size: 18px;
      height: 44px;
      line-height: 40px;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
  }

  .btn1 {
    background: linear-gradient(to bottom, #0c0a03, #373633);
  }

  .btn2 {
    background-color: #b81c25;
  }
}
/deep/ .responsive-dialog {
  background: transparent !important;
  box-shadow: none !important;

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    padding: 0 !important;
    background: transparent !important;
  }

  .el-dialog__headerbtn {
    display: none !important;
  }
}

/deep/ .season2-dialog {
  margin-bottom: 0 !important;

  .el-dialog__body {
    padding: 0;
  }
}
</style>
